import { Component, computed, signal } from '@angular/core';
import { TabsModule } from 'primeng/tabs';
import { FilesComponent } from '../settings/knowledgebase/files/files.component';
import { KnowledgeMappingComponent } from '../settings/knowledgebase/knowledge-mapping/knowledge-mapping.component';
import { KnowledgeBaseStoreComponent } from '../settings/knowledgebase/knowledge-base-store/knowledge-base-store.component';
import { TabConfig } from 'src/app/@shared/components/file-selection';
import { TooltipModule } from 'primeng/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { KNOWLEDGE_SCOPE } from '../../models/contract-management.model';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-project-knowledge',
  standalone: true,
  imports: [
    TabsModule,
    TooltipModule,
    CommonModule,
    FilesComponent,
    KnowledgeMappingComponent,
    KnowledgeBaseStoreComponent
  ],
  providers: [ConfirmationService],
  templateUrl: './project-knowledge.component.html',
  styleUrl: './project-knowledge.component.scss'
})
export class ProjectKnowledgeComponent {
  selectedTabIndex = signal<number>(0);
  projectId = signal<string>('');
  projectKnowledgeTabs = signal<TabConfig[]>([
    {
      id: '0',
      label: 'Project knowledge',
      tooltip: 'View all project knowledge'
    },
    {
      id: '1',
      label: 'Knowledge bases',
      tooltip: 'View all knowledge bases'
    },
    {
      id: '2',
      label: 'Knowledge mapping',
      tooltip: 'View all knowledge mapping'
    }
  ])

  KNOWLEDGE_SCOPE = computed(() => {
    return KNOWLEDGE_SCOPE
  })

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute
  ) {
    this._activatedRoute.queryParams.subscribe(params => {
      this.projectId.set(params['projectId']);

      // // Load data whenever projectId changes
      // if (this.projectId) {
      //   this.loadProjectData();
      // }
    })
  }

  handleTabChange(event: any) {
    let index: number;

    if (event === undefined || event === null) {
      index = 0;
    } else if (typeof event === 'string') {
      index = parseInt(event, 10);
    } else if (typeof event === 'number') {
      index = event;
    } else {
      // Fallback
      index = 0;
    }

    // // Only update if the index actually changed
    if (this.selectedTabIndex() !== index) {
      this.selectedTabIndex.set(index);
    }
  }

  goBack() {
    // go back to the previous page
    window.history.back();
  }

}
